import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withAppContext } from '../../contexts/app';

import ContactUsModal from '../ContactUsModal';

class ContactUs extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modalIsOpen: false
    };
  }

  handleModalOpenClick = () => {
    this.setState({ modalIsOpen: true });
  }

  handleModalClosed = () => {
    this.setState({ modalIsOpen: false });
  }

  render() {
    if (this.props.app.isOfflineMode) { return null; }

    return (
      <div className="cta-contact">
        <div className="container">
          <h2>{this.props.heading}</h2>
          <p>{this.props.subheading}</p>

          <button
            className="button button--large button--gradient"
            onClick={this.handleModalOpenClick}
          >
            Send a Message
          </button>

          {this.state.modalIsOpen && <ContactUsModal onModalClose={this.handleModalClosed} />}
        </div>
      </div>
    );
  }
}

ContactUs.defaultProps = {
  heading: 'Contact Us',
  subheading: 'Send us your questions, comments, ideas, and suggestions!'
};

ContactUs.propTypes = {
  app: PropTypes.object.isRequired,
  heading: PropTypes.any,
  subheading: PropTypes.any
};

export default withAppContext(ContactUs);
